export default "__VITE_ASSET__CavpmxkZ__"